import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthGuard } from './shared/guards/auth.guard';
import { HomeComponent } from './home/home.component';
import { UserprofileComponent } from './userprofile/userprofile.component'

@NgModule({
  imports: [
    RouterModule.forRoot([
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      { path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
      { path: 'userprofile', component: UserprofileComponent, canActivate: [AuthGuard] },
      { path: 'forgot-pass', loadChildren: 'app/forgot-pass/forgot-pass.module#ForgotPassModule' },
      { path: 'login', loadChildren: 'app/login/login.module#LoginModule' },
      { path: 'admin', loadChildren: 'app/admin/admin.module#AdminModule', canActivate: [AuthGuard] },
      { path: 'lead', loadChildren: 'app/lead/lead.module#LeadModule', canActivate: [AuthGuard] },
      { path: 'employee', loadChildren: 'app/employee/employee.module#EmployeeModule', canActivate: [AuthGuard] },
      { path: 'vendor', loadChildren: 'app/vendor/vendor.module#VendorModule', canActivate: [AuthGuard] },
      { path: 'product', loadChildren: 'app/product/product.module#ProductModule', canActivate: [AuthGuard] },
      { path: 'order', loadChildren: 'app/order/order.module#OrderModule', canActivate: [AuthGuard] },
      { path: 'customer', loadChildren: 'app/customer/customer.module#CustomerModule', canActivate: [AuthGuard] },
      { path: 'accounting', loadChildren: 'app/accounting/accounting.module#AccountingModule', canActivate: [AuthGuard] },
      { path: 'procurement-request', loadChildren: 'app/procurement-request/procurement-request.module#ProcurementRequestModule', canActivate: [AuthGuard] },
      { path: 'sales', loadChildren: 'app/sales/sales.module#SalesModule', canActivate: [AuthGuard] },
      { path: 'reports', loadChildren: 'app/reports/reports.module#ReportsModule', canActivate: [AuthGuard] },
      { path: 'formula', loadChildren: 'app/formula/formula.module#FormulaModule', canActivate: [AuthGuard] }
    ])],
  exports: [
    RouterModule
  ],
  providers: [AuthGuard]
})
export class AppRouting {
}



// WEBPACK FOOTER //
// ./src/app/app.routing.ts